import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { confirmAndLogout } from '../../utils/session';
import { useAuth } from '../../context/authContext';

const ImportarDatos = () => {
  const navigate = useNavigate();
  const { user: authUser } = useAuth();

  const getUserString = () => {
    try {
      const s = sessionStorage.getItem('user') || localStorage.getItem('user') || '';
      if (!s) return authUser?.user || '';
      try {
        const o = JSON.parse(s);
        return (o.user || o.id || o.email || o.usuario || o.username || '') + '';
      } catch (_) { return s + ''; }
    } catch (_) { return ''; }
  };

  const handleVolver = () => navigate('/superadmin');

  useEffect(() => {
    const handlePopState = () => {
      const didLogout = confirmAndLogout(navigate, '/login');
      if (!didLogout) {
        try { window.history.pushState(null, '', window.location.href); } catch (_) {}
      }
    };
    window.history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, [navigate]);

  const options = [
    { title: 'Fichajes',     image: '/images/seguimiento.png', path: '/superadmin/fichajes' },
    { title: 'Gestión de Usuarios', image: '/images/gestion_usuarios.png', path: '/admin/usuarios' },
    { title: 'Gestión de Pisos',    image: '/images/gestion_pisos.png',    path: '/admin/pisos' },
    { title: 'Sustituciones',      image: '/images/sustituciones.png', path: '/superadmin/sustituciones' },
    { title: 'Gestión de Alumnos',  image: '/images/gestion-alumnos.png', path: '/admin/alumnos' },
    { title: 'Encargados de supervisoras', image: '/images/encargado-supervisoras.png', path: '/admin/encargados-supervisoras' },
    { title: 'Historial',          image: '/images/historial.png', path: '/superadmin/historial' },
    { title: 'Permisos',     image: '/images/notificaciones.png', path: '/superadmin/notificaciones' },
    { title: 'Uso de la app',      image: '/images/info-uso-app.png', path: '/superadmin/uso-app' },
  ];

  return (
    <div style={{ ...styles.container, position: 'relative' }}>
      <div style={{ position: 'absolute', top: 12, left: 12, zIndex: 50 }}>
        <button
          onClick={handleVolver}
          style={{
            padding: '10px 22px',
            borderRadius: 20,
            background: 'linear-gradient(135deg, #3b82f6, #1d4ed8)',
            color: '#fff',
            border: 'none',
            cursor: 'pointer',
            fontWeight: 700,
            fontSize: 15,
            boxShadow: '0 2px 8px rgba(29,78,216,0.35)',
            letterSpacing: '0.3px',
          }}
        >
          ← Volver
        </button>
      </div>

      <h1 style={styles.title}>🗂️ Gestionar datos — <strong style={{ color: '#007bff' }}>{getUserString()}</strong></h1>

      <div style={styles.buttonContainer}>
        {options.map((option) => (
          <button key={option.title} onClick={() => navigate(option.path)} style={styles.button}>
            <img src={option.image} alt={option.title} style={styles.image}
              onError={(e) => { if (!e.currentTarget.dataset.fallback) { e.currentTarget.dataset.fallback = "1"; e.currentTarget.src = "/images/gestion_usuarios.png"; } }} />
            <span style={styles.label}>{option.title}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

const styles = {
  container: {
    textAlign: 'center',
    padding: '40px',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  },
  title: {
    marginBottom: '30px',
    color: '#333',
    marginTop: 60,
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    alignItems: 'center',
  },
  button: {
    width: '90%',
    maxWidth: '400px',
    padding: '20px',
    border: '2px solid #007bff',
    borderRadius: '10px',
    backgroundColor: 'transparent',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '20px',
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out',
  },
  image: {
    width: '50px',
    height: '50px',
    objectFit: 'contain',
  },
  label: {
    fontSize: '20px',
    fontWeight: 'bold',
    color: '#007bff',
    textAlign: 'center',
  },
};

export default ImportarDatos;
